import React from 'react';
import styled from 'styled-components';
import { pluralize } from '../../../../utils/formatText';
import ThinDivider from '../../../../components/ThinDivider';
import CapricaTableStatusFilter from '../../components/CapricaTableStatusFilter';
import DefaultRoleMenu from './DefaultRoleMenu';
import {
  IRoleMetaFieldsFragment,
  PermissionKey,
} from '../../../../utils/apollo/graphqlSchema';
import SearchInput from '../../../../components/Form/SearchInput';
import { ICapricaTableStatus } from '../../types';
import usePermission from '../../../../utils/hooks/permissionHooks/usePermission';
import * as PermissionControlUI from '../../../PermissionControls/PermissionControlsUI';
import { AnalyticsLink } from '../../../../components/Button';
import { appRoutes } from '../../../../path';
import PermissionElementWrapper from '../../../PermissionControls/PermissionElementWrapper';
import { TotalLabel } from '../../../PermissionControls/PermissionControlsUI';

interface IProps {
  roles: IRoleMetaFieldsFragment[];
  total: number;
  searchTerm: string;
  setSearchTerm: (searchTerm: string) => void;
  statuses: ICapricaTableStatus[];
  setStatuses: (statuses: ICapricaTableStatus[]) => void;
}

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  column-gap: 16px;
  row-gap: 8px;
`;
const FiltersContainer = styled(Container)`
  margin-right: auto;
`;

const RolesFilters = ({
  roles,
  total,
  searchTerm,
  setSearchTerm,
  statuses,
  setStatuses,
}: IProps) => {
  const { checkIsPermitted } = usePermission();
  const isPermittedToCreate = checkIsPermitted({
    requiredPermissionKeys: [PermissionKey.AdminCreate],
  });

  return (
    <Container>
      <FiltersContainer>
        <TotalLabel>
          {total} {pluralize('Role', total)}
        </TotalLabel>
        <ThinDivider layout="vertical" size="short" />
        <CapricaTableStatusFilter
          statuses={statuses}
          setStatuses={setStatuses}
        />
        <ThinDivider layout="vertical" size="short" />
        <DefaultRoleMenu roles={roles} />
      </FiltersContainer>
      <PermissionElementWrapper isPermitted={isPermittedToCreate}>
        <PermissionControlUI.HeaderCreateAction
          forwardedAs={AnalyticsLink}
          to={isPermittedToCreate ? appRoutes.permission.createRole : ''}
          disabled={!isPermittedToCreate}
          trackContext="roles"
          trackAction="create role"
        >
          Create Role
        </PermissionControlUI.HeaderCreateAction>
      </PermissionElementWrapper>
      <SearchInput
        placeholder={'Search Roles'}
        onChange={setSearchTerm}
        value={searchTerm}
      />
    </Container>
  );
};

export default RolesFilters;
